<template>
    <div class="layout-footer">
        <span class="footer-text" style="margin-right: 5px">&copy;</span>
        <span class="footer-text" style="margin-left: 5px">All Rights Reserved</span>
    </div>
</template>

<script>
    export default {
        name: "AppFooter"
    }
</script>

<style scoped>
    .layout-footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 4px 10px;
        display: block;
    }
</style>